module.exports = __webpack_public_path__ + "static/media/inbox.a97885b5.svg";